import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgCloudFullLogoLight = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-cloud-full-logo-light';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 24,
    fill: "none",
    viewBox: "0 0 130 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#26D07C",
      d: "M22 13v5l-9 4v-9zm0-2V6l-9-4v9zM2 6v12l9 4V2z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#222",
      d: "M35.313 5.226C30.56 5.226 28 7.92 28 12.671s2.56 7.445 7.182 7.445c3.037 0 5.49-1.532 6.468-4.647h-3.168c-.608 1.055-1.48 1.716-3.3 1.716-2.72 0-3.802-1.452-3.802-4.488v-.079c0-3.037 1.083-4.461 3.933-4.461 1.69 0 2.56.58 3.169 1.585h3.168c-.977-3.01-3.3-4.514-6.337-4.514zm33.268 8.793q0 3.168 3.168 3.168t3.168-3.168V5.544h3.327v14.258H75.13v-2.113c-.871 1.505-2.297 2.429-4.673 2.429-3.38 0-5.2-1.848-5.2-5.544v-9.03h3.326v8.475zm51.035 0q0 3.168 3.168 3.168t3.168-3.168V5.544h3.327v14.258h-3.115v-2.113c-.871 1.505-2.297 2.429-4.673 2.429-3.38 0-5.201-1.848-5.201-5.544v-9.03h3.327v8.475zm-31.867 3.168c2.852 0 3.96-1.452 3.96-4.489v-.078c0-3.037-1.108-4.436-3.96-4.436s-3.96 1.4-3.96 4.436v.079c0 3.036 1.108 4.488 3.96 4.488M94.93 0v19.802h-3.168v-2.113c-.899 1.426-2.27 2.429-4.62 2.429-4.489 0-6.733-3.115-6.733-7.235 0-4.514 2.244-7.63 6.733-7.63 1.954 0 3.827.952 4.46 2.22V0zM42.945 19.802h3.327V0h-3.328zm12.831.318c-4.541 0-7.392-2.825-7.392-7.445s2.853-7.445 7.392-7.445c4.54 0 7.392 2.825 7.392 7.445s-2.852 7.445-7.392 7.445m-4.013-7.42c0 3.037 1.108 4.489 4.013 4.489 2.906 0 4.014-1.452 4.014-4.489v-.078c0-3.037-1.108-4.461-4.014-4.461-2.905 0-4.013 1.426-4.013 4.46zm61.279-7.154h1.585v3.168h-2.376c-2.113 0-2.825.977-2.825 2.56v8.528h-3.327V5.518h3.168v2.64c.634-1.822 1.901-2.612 3.777-2.612zM100.5 20.12c1.452 0 2.376-.871 2.376-2.35s-.924-2.35-2.376-2.35-2.375.87-2.375 2.35.924 2.35 2.375 2.35"
    })]
  }));
});
export default SvgCloudFullLogoLight;